/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

/**
 * @description 204 response
 */
export const optionsSubscriptionForm204Schema = z.any();

/**
 * @description 505 response
 */
export const optionsSubscriptionForm505Schema = z.any();

export const optionsSubscriptionFormMutationResponseSchema = z.lazy(() => optionsSubscriptionForm204Schema);
